import _extends from '@babel/runtime-corejs3/helpers/extends';
import _typeof from '@babel/runtime-corejs3/helpers/typeof';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import { c as clsx } from '../clsx.m-7e9a4a81.js';
import React__default from 'react';
import { T as Typography } from '../Typography-b5ab7944.js';
import '@babel/runtime-corejs3/core-js-stable/array/is-array';
import '@babel/runtime-corejs3/core-js-stable/object/keys';
import '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import '@babel/runtime-corejs3/core-js-stable/instance/filter';
import '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import '@babel/runtime-corejs3/core-js-stable/object/define-property';
import '@babel/runtime-corejs3/helpers/defineProperty';

var _excluded = ["value", "onChange", "label", "disabled", "children"];
var Text = Typography.Text;

var Switch = function Switch(_ref) {
  var value = _ref.value,
      _onChange = _ref.onChange,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? null : _ref$label,
      disabled = _ref.disabled,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  var color = disabled ? 'light-grey' : !value ? 'dark-grey' : 'black';
  var labelNode = _typeof(label) !== undefined ? /*#__PURE__*/React__default.createElement(Text, {
    preset: "h5",
    color: color
  }, label) : null;
  var sharpNode = /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("input", {
    type: "checkbox",
    checked: value,
    disabled: disabled,
    onChange: function onChange(e) {
      return _onChange === null || _onChange === void 0 ? void 0 : _onChange(e.target.checked);
    }
  }), /*#__PURE__*/React__default.createElement("div", {
    className: clsx('smb-switch__sharp', label && 'smb-switch__sharp--labeled')
  }));
  return /*#__PURE__*/React__default.createElement("label", _extends({
    className: clsx('smb-switch', value && 'smb-switch--active', disabled && 'smb-switch--disabled')
  }, rest), typeof children === 'function' ? children({
    sharp: sharpNode,
    label: labelNode,
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    value: value,
    color: color
  }) : /*#__PURE__*/React__default.createElement(SwitchInner, null, sharpNode, labelNode));
};

var SwitchInner = function SwitchInner(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "smb-switch__inner"
  }, children);
};

Switch.Inner = SwitchInner;

export default Switch;
